import axios from 'axios';

import { store } from '../../store';
import { makeSelectAuthUser } from './selectors';

export const API_BASE_URL = 'https://agent.perxtech.io/api/v1';

export async function aiChatBotApi(
  path: string,
  options: {
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    data?: any;
    params?: any;
  } = {}
) {
  const state = store.getState();
  const authUserSelector = makeSelectAuthUser();
  const authUser = authUserSelector(state);
  const bearerToken = authUser?.bearer_token;

  const method = options.method || 'POST';
  const config: any = {
    method,
    url: `${API_BASE_URL}${path}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`
    }
  };
  if (options.data) config.data = options.data;
  if (options.params) config.params = options.params;

  return axios(config);
}

export async function downloadReport(cacheKey: string) {
  const state = store.getState();
  const authUserSelector = makeSelectAuthUser();
  const authUser = authUserSelector(state);
  const bearerToken = authUser?.bearer_token;

  const response = await fetch(`${API_BASE_URL}/tools/download-cached-query`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`
    },
    body: JSON.stringify({ cache_key: cacheKey })
  });
  const result = await response.json();
  if (result.success) {
    try {
      const blob = new Blob([result.csv_content], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = result.filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      store.dispatch({
        type: 'AI_CHATBOT_SET_TOKENS',
        payload: {
          total_tokens: result.token_usage?.max_tokens,
          unused_tokens: result.token_usage?.remaining_tokens
        }
      });
    } catch (error) {
      console.error('Error during file download:', error);
    }
  } else {
    console.error('Download failed:', result.error);
  }
}
